import axios from "axios";
import { cleanParams } from "src/utils/cleanParams";
import { DevConfig } from "src/utils/config";

const API_BASE_URL = DevConfig.API_BASE_URL

const AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 5000, 
  headers: {
    "Content-Type": "application/json",
  },
});

AxiosInstance.interceptors.request.use(
  (config) => {
    if (config.params) {
      config.params = cleanParams(config.params);
    }
    if (config.data && config.headers['Content-Type'] === 'application/json') {
      config.data = cleanParams(config.data);
    }
    return config;
  },
  (error) => {
    console.log(error)
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
    if (error.response.status === 500) {
        console.error("서버 오류");
      }
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;
